import React from "react";
import Chart from "react-apexcharts";

const StatsBarChart = ({ series, question, plotOptions }) => {
  let plotSetting = false;
  const seriesData = series;

  if (plotOptions) {
    plotSetting = true;
  }

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex">
                    <div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">
                    <div class="apexcharts-tooltip-z-group">
                      <strong>Class: ${seriesData[0].data[dataPointIndex].x}</strong>
                    </div>
                      <div class="apexcharts-tooltip-z-group">
                        <span class="apexcharts-tooltip-text-z-label">Counts: </span>
                        <span class="apexcharts-tooltip-text-z-value">${seriesData[0].data[dataPointIndex].count}</span>
                      </div>
                      <div class="apexcharts-tooltip-z-group">
                        <span class="apexcharts-tooltip-text-z-label">Percent:</span>
                        <span class="apexcharts-tooltip-text-z-value">${seriesData[0].data[dataPointIndex].y}</span>
                      </div>
                      <div class="apexcharts-tooltip-z-group">
                        <span class="apexcharts-tooltip-text-z-label">Error:</span>
                        <span class="apexcharts-tooltip-text-z-value">${seriesData[0].data[dataPointIndex].error}%</span>
                      </div>
                    </div>
                  </div>`;
      },
    },
    plotOptions: {
      bar: {
        horizontal: plotSetting,
      },
    },
    colors: ["#009c00"],
    dataLabels: {
      formatter: function (val, opt) {
        const goals =
          opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals;

        if (goals && goals.length) {
          return `${val} %`;
        }
        return val;
      },
    },
    legend: {
      show: false,
      showForSingleSeries: true,
      customLegendItems: ["Actual", "Expected"],
      markers: {
        fillColors: ["#28a0fb", "#555"],
      },
    },
    grid: {
      show: false,
    },
    yaxis: {
      show: true,
    },
    xaxis: {
      position: "bottom",
      labels: {
        offsetY: 2,
      },
    },
  };

  return (
    <div className="col-12">
      <div className="col-12 text-center mt-3" style={{ fontSize: "16px" }}>
        <strong>{question}</strong>
      </div>

      <Chart options={options} series={series} type="bar" height="280px" />
    </div>
  );
};

export default StatsBarChart;
